export const PROJECT_MILESTONE_STATUS_CREATE = 'PROJECT_MILESTONE_STATUS_CREATE'
export const PROJECT_MILESTONE_STATUS_CREATE_SUBMIT = 'PROJECT_MILESTONE_STATUS_CREATE_SUBMIT'
export const PROJECT_MILESTONE_STATUS_CREATE_FAILURE = 'PROJECT_MILESTONE_STATUS_CREATE_FAILURE'

export const PROJECT_MILESTONE_STATUS_UPDATE = 'PROJECT_MILESTONE_STATUS_UPDATE'
export const PROJECT_MILESTONE_STATUS_UPDATE_SUBMIT = 'PROJECT_MILESTONE_STATUS_UPDATE_SUBMIT'
export const PROJECT_MILESTONE_STATUS_UPDATE_FAILURE = 'PROJECT_MILESTONE_STATUS_UPDATE_FAILURE'

export const PROJECT_MILESTONE_STATUS_DELETE = 'PROJECT_MILESTONE_STATUS_DELETE'
export const PROJECT_MILESTONE_STATUS_DELETE_SUBMIT = 'PROJECT_MILESTONE_STATUS_DELETE_SUBMIT'
export const PROJECT_MILESTONE_STATUS_DELETE_FAILURE = 'PROJECT_MILESTONE_STATUS_DELETE_FAILURE'
